import React from 'react';

import {Section} from '../containers';
import {Service} from '../elements';

const Services = ({api, translate}) => {
	const {title, info} = api.getServices();
	return (
		<Section id="services" className="padd-tb-60 grey lighten-5 services-wrap">
			<h2 className="section-title">{translate(title)}</h2>
			<div className="row">
				{info.map((info, index) => (
					<Service key={index} translate={translate} className="col l3 m3 s12" {...info} />
				))}
			</div>
		</Section>
	);
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/sections/Services.js